let lastTraceId: string | null = null;

export const setLastTraceId = (traceId: string) => {
  lastTraceId = traceId;
};

export const getLastTraceId = () => lastTraceId;
